/**
 * Feedback button (spec 05 section 6.1): limits shared by `POST /v1/feedback`
 * and the web client that compresses the screenshot to fit them.
 */
export const FEEDBACK_LIMITS = {
    /** Description the user typed; the hub keeps 4000 characters, the rest is our signature line. */
    messageMaxLength: 3400,
    /**
     * Longest `data:` URL of the screenshot. The API's JSON body limit is 1 MB,
     * so the image stays below it with room for the other fields.
     */
    imageMaxDataUrlLength: 900_000,
    /** Longest edge the client scales a screenshot to before compressing. */
    imageMaxEdge: 2560,
    pageUrlMaxLength: 2000,
    pageTitleMaxLength: 300,
    viewportMaxLength: 40,
};
//# sourceMappingURL=feedback.js.map